import { ChangeDetectionStrategy, Component, ViewChild, Injector } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTabGroup } from '@angular/material/tabs';
import { ComponentStore } from '@ngrx/component-store';
import { Store } from '@ngrx/store';
import { PermissionFacade } from '../../../../../../../modules/permission/facades/permission.facade';
import { PermSetLine, PermSetModel, UserModel } from '../../../../../../../models/user-permissions.model';
import { ViewColumnComponent } from '../../../../../../../view-column.component';
import { AppConfig } from '../../../../../../../visa';
import { Observable, zip } from 'rxjs';
import { SubSink } from 'subsink2';
import { app_perm_set_line_RowClass } from 'blg-akaun-ts-lib';
import { UserPermActions } from '../../../../../../../modules/permission/user-permissions-controller/actions';
import { UserPermSelectors } from '../../../../../../../modules/permission/user-permissions-controller/selectors';
import { PermissionStates } from '../../../../../permission-controller/root';
import { TranslateService } from "@ngx-translate/core";

interface LocalState {
  deactivateReturn: boolean;
  deactivateList: boolean;
  deactivateAdd: boolean;
  selectedIndex: number;
}

@Component({
  selector: 'app-user-permission-set-details',
  templateUrl: './user-permission-set-details.component.html',
  styleUrls: ['./user-permission-set-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ComponentStore]
})
export class UserPermissionSetDetailsComponent extends ViewColumnComponent {

  @ViewChild(MatTabGroup, {static: true}) matTab: MatTabGroup;

  protected readonly index = 10;
  private localState: LocalState;

  // info. about previous local states
  prevIndex: number;
  private prevLocalState: any;

  // initialise local states
  readonly localState$ = this.viewColFacade.selectLocalState(this.index);
  readonly deactivateReturn$ = this.componentStore.select(state => state.deactivateReturn);
  readonly selectedIndex$ = this.componentStore.select(state => (state.selectedIndex));
  readonly deactivateAdd$ = this.componentStore.select(state => state.deactivateAdd);

  // api visa
  apiVisa = AppConfig.apiVisa;

  toggleColumn$: Observable<boolean>;

  // subSink is to ensure all subscribe calls are unsubscribed to once the component is destroyed
  private subSink = new SubSink;

  public form: FormGroup;

  currentIndexTab: number;

  formDisabled: boolean = false;

  currentUser: UserModel;
  selectedUser: UserModel;
  readonly selectedPermSet$ = this.store.select(UserPermSelectors.selectSelectedPermSet);
  selectedPermSet: app_perm_set_line_RowClass[];
  permSetGuid: string;

  appletGuid = sessionStorage.getItem('appletGuid');

  //translation variable
  title: string;
  details_text: string;
  code_text: string;
  name_text: string;
  unlink_text: string;
  permission_set_line_text: string;
  back_button: string;

  constructor(
    private fb: FormBuilder,
    private store: Store<PermissionStates>,
    private viewColFacade: PermissionFacade,
    private readonly componentStore: ComponentStore<LocalState>,
    private injector: Injector
  ) {
    super();
    const translateService = this.injector.get(TranslateService, null);
    if (translateService) {
      translateService.get('labels').subscribe(res => {
        this.title = res.view_permission_set_listing_details;
        this.details_text = res.details;
        this.code_text = res.code;
        this.name_text = res.name;
        this.unlink_text = res.unlink;
        this.permission_set_line_text = res.permission_set_line;
        this.back_button = res.back_button;
      });
    } else {
      // Fallback if translation service is unavailable
      this.title = 'View Permission Set Listing Details';
      this.details_text = 'Details';
      this.code_text = 'Code';
      this.name_text = 'Name';
      this.unlink_text = 'Unlink';
      this.permission_set_line_text = 'Permission Set Line';
      this.back_button = 'Back';
    }
  }

  /**
   * Lifecycle method: Called when the component is first initialised.
   */
  ngOnInit() {
    this.subSink.sink = this.localState$.subscribe(a => {
      this.localState = a;
      this.componentStore.setState(a);
    });

    this.toggleColumn$ = this.viewColFacade.toggleColumn$;
    this.subSink.sink = this.viewColFacade.prevIndex$.subscribe(resolve => this.prevIndex = resolve);
    this.subSink.sink = this.viewColFacade.prevLocalState$().subscribe(resolve => this.prevLocalState = resolve);

    this.form = this.fb.group({
        code: [''],
        name: [''],
    })

    this.subSink.sink = this.selectedPermSet$
    .subscribe(permSet => {
      console.log("permSet",permSet);
      // set form values
      this.form.patchValue({
        code: permSet.app_perm_set_hdr.code,
        name: permSet.app_perm_set_hdr.name
      });

      this.permSetGuid = permSet.app_perm_set_hdr.guid.toString();
      this.selectedPermSet = permSet.app_perm_set_lines;

      console.log("permSet.app_perm_set_line",permSet.app_perm_set_lines);
      console.log("this.selectedPermSet",this.selectedPermSet);

    })

  }

  goToPermSetLineDetailAndPermDefinition(permSetLineEntity) {
    console.log("goToPermSetLineDetailAndPermDefinition(UserPermActions => Role still need to edit)");

    // dispatch ngrx action
    this.store.dispatch(UserPermActions.selectPermSetLine({permSetLine: permSetLineEntity}));

    if (!this.localState.deactivateList) {
      this.viewColFacade.updateInstance(this.index,
        {
          ...this.localState,
          deactivateAdd: false,
          deactivateList: false,
          deactivateReturn: true,
        });
      // trigger the next view column
      this.viewColFacade.onNextAndReset(this.index, 8);
    }
  }

  /**
   * Unlink permission set.
   */
  onUnlink() {
    this.store.dispatch(UserPermActions.unlinkPermSetInit({assigneeHdrTable: "app_login_subject", appletGuid: this.appletGuid, permSetGuid: this.permSetGuid}));
    this.onReturn();
  }

  /**
   * Return to the previous drawer/view column.
   */
   onReturn() {
    this.viewColFacade.updateInstance(this.prevIndex, {
      ...this.prevLocalState,
      deactivateReturn: false,
      deactivateAdd: false
    });
    this.viewColFacade.onPrev(this.prevIndex);
  }

  /**
   * Lifecycle method: Called when this component is destroyed.
   */
  ngOnDestroy() {
    if (this.matTab) {
      this.viewColFacade.updateInstance(this.index, {
        ...this.localState,
        selectedIndex: this.matTab.selectedIndex
      });
    }
    this.subSink.unsubscribe();
  }

}
